import {getBaseURL} from "./axios";
import {EDUCATION_REQUEST_URL} from '../constants/environments';

const apiBaseUrl = getBaseURL(null).replace(/\/+$/, '');

export const API_URL = {
  EDUCATION_MODULE: EDUCATION_REQUEST_URL,
  USER_MODULE: apiBaseUrl + '/user/api/v2',
  CONTENT_MODULE: apiBaseUrl + '/content/api/v2',
  QUESTION_MODULE: apiBaseUrl + '/question/api/v2',
};
